<template>
<box-view class="return-order-history" title="Lịch sử đơn hoàn trả" @close="$router.back()">
    <!-- FILTER -->
    <div class="container card mb-2 p-2">
        <div class="row g-2">
            <div class="col-md-4">
                <input v-model="searchQuery" class="form-control form-control-sm" placeholder="Tìm mã hoàn / đơn gốc / khách / SĐT" />
            </div>
            <div class="col-md-2">
                <input v-model="fromDate" type="date" class="form-control form-control-sm" />
            </div>

            <div class="col-md-2">
                <input v-model="toDate" type="date" class="form-control form-control-sm" />
            </div>
        </div>

    </div>

    <!-- TABLE -->
    <div class="table-responsive container">
        <table class="table table-sm table-bordered align-middle">
            <thead class="table-warning">
                <tr>
                    <th>#</th>
                    <th>Mã hoàn</th>
                    <th>Đơn gốc</th>
                    <th>Khách hàng</th>
                    <th>Tiền hoàn</th>
                    <th>Người tạo</th>
                    <th>Thời gian</th>
                    <th width="40"></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(order, index) in paginatedOrders" :key="order.id">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td class="fw-bold text-danger">{{ order.id }}</td>
                    <td>{{ order.orderId }}</td>

                    <td>
                        <div class="fw-bold">
                            {{ order.customer.name || 'Khách lẻ' }}
                        </div>
                        <small class="text-muted">
                            {{ order.customer.phone }}
                        </small>
                    </td>

                    <td class="fw-bold text-danger">
                        {{ order.totalRefund.toLocaleString() }}
                    </td>

                    <td>{{ order.user.name }}</td>
                    <td>{{ formatTime(order.createdAt) }}</td>

                    <td class="text-center">
                        <button class="btn btn-sm btn-primary" @click="openDetail(order)">
                            <i class="fas fa-eye"></i>
                        </button>
                    </td>
                </tr>

                <tr v-if="filteredReturnOrders.length === 0">
                    <td colspan="8" class="text-center text-muted">
                        Chưa có đơn hoàn
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- DETAIL POPUP -->
    <div v-if="showDetail" class="modal-backdrop-custom">
        <div class="modal-custom">

            <div class="modal-header bg-danger text-white">
                <h6 class="mb-0">CHI TIẾT ĐƠN HOÀN</h6>
                <button class="btn btn-sm btn-light" @click="showDetail = false">
                    ✕
                </button>
            </div>

            <div class="modal-body">
                <!-- INFO -->
                <div class="info-box mb-3">
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1">Mã hoàn:</b>
                        {{ selectedOrder.id }}
                    </div>
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1">Đơn gốc:</b>
                        {{ selectedOrder.orderId }}
                    </div>
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1">Khách:</b>
                        {{ selectedOrder.customer.name }}
                    </div>
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1">Điện thoại:</b>
                        {{ selectedOrder.customer.phone }}
                    </div>
                    <div class="mb-2 d-flex">
                         ▶ <b class="mx-1">Người tạo:</b>
                         {{ selectedOrder.user ? selectedOrder.user.name : '—' }}
                     </div>
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1">Lý do:</b>
                        {{ selectedOrder.reason || '—' }}
                    </div>
                    <div class="mb-2 d-flex">
                        ▶ <b class="mx-1 ">Tạo lúc:</b>
                        {{ formatTime(selectedOrder.createdAt) }}
                    </div>
                </div>

                <!-- CART -->
                <table class="table table-sm table-bordered">
                    <thead class="table-warning">
                        <tr>
                            <th>#</th>
                            <th>Sản phẩm</th>
                            <th>Giá bán</th>
                            <th>SL hoàn</th>
                            <th>Tiền hoàn</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, i) in selectedOrder.cart" :key="i">
                            <td>{{ i + 1 }}</td>
                            <td>{{ item.product_name_snap || item.name }}</td>
                            <td>{{ item.price.toLocaleString() }}</td>
                            <td>{{ item.quantity }}</td>
                            <td class="fw-bold text-danger">
                                {{
                                        (item.price * item.quantity).toLocaleString()
                                    }}
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td colspan="4" class="text-end fw-bold">
                                Tổng tiền hoàn
                            </td>
                            <td class="fw-bold text-danger">
                                {{
                                        (selectedOrder.totalRefund || 0).toLocaleString()
                                    }}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </div>
    </div>
    <nav v-if="totalPages > 1" class="mt-3">
        <ul class="pagination pagination-sm justify-content-center flex-wrap">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(1)" title="Trang đầu">««</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)">«</a>
            </li>
            <li v-for="(page, idx) in visiblePages" :key="'p'+idx"
                class="page-item"
                :class="{ active: page === currentPage, disabled: page === '...' }">
                <a class="page-link" href="#"
                   @click.prevent="page !== '...' && goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)">»</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)" title="Trang cuối">»»</a>
            </li>
        </ul>
        <div class="text-center text-muted small">Trang {{ currentPage }} / {{ totalPages }}</div>
    </nav>
</box-view>
</template>

<script>
export default {
    name: 'ReturnOrderHistory',

    props: ['returnOrders'],

    data() {
        return {
            searchQuery: '',
            fromDate: '',
            toDate: '',
            pageSize: 30,
            currentPage: 1,

            showDetail: false,
            selectedOrder: null
        }
    },

    computed: {
        filteredReturnOrders() {
            return (this.returnOrders || []).filter(o => {
                const keyword = (this.searchQuery || '').toLowerCase();
                
                const id = o.id || '';
                const orderId = o.orderId || '';
                const custName = o.customer?.name || '';
                const custPhone = o.customer?.phone || '';

                const matchText =
                    id.toLowerCase().includes(keyword) ||
                    orderId.toLowerCase().includes(keyword) ||
                    custName.toLowerCase().includes(keyword) ||
                    custPhone.includes(keyword);

                const orderDate = new Date(o.createdAt);
                
                let from = null;
                let to = null;

                if (this.fromDate) {
                    from = new Date(this.fromDate);
                    from.setHours(0, 0, 0, 0);
                }

                if (this.toDate) {
                    to = new Date(this.toDate);
                    to.setHours(23, 59, 59, 999);
                }

                const matchDate =
                    (!from || orderDate >= from) &&
                    (!to || orderDate <= to);

                return matchText && matchDate;
            });
        },
        totalPages() {
            return Math.ceil(this.filteredReturnOrders.length / this.pageSize)
        },
        visiblePages() {
            const total = this.totalPages;
            const current = this.currentPage;
            const delta = 2;
            const pages = [];
            if (total <= 7) {
                for (let i = 1; i <= total; i++) pages.push(i);
                return pages;
            }
            pages.push(1);
            const rangeStart = Math.max(2, current - delta);
            const rangeEnd = Math.min(total - 1, current + delta);
            if (rangeStart > 2) pages.push('...');
            for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
            if (rangeEnd < total - 1) pages.push('...');
            pages.push(total);
            return pages;
        },
        paginatedOrders() {
            const start = (this.currentPage - 1) * this.pageSize
            const end = start + this.pageSize
            return this.filteredReturnOrders.slice(start, end)
        }

    },

    methods: {
        goToPage(page) {
            if (page < 1) page = 1;
            if (page > this.totalPages) page = this.totalPages;
            this.currentPage = page;
        },
        openDetail(order) {
            this.selectedOrder = order;
            this.showDetail = true;
        },

        formatTime(time) {
            return new Date(time).toLocaleString();
        },
        getStatusText(status) {
            // ...
        }
    },
    watch: {
        searchQuery() {
            this.currentPage = 1
        }
    }
};
</script>
